export const MuiSkeleton = {
    styleOverrides: {
        root: ({ theme }) => ({
            backgroundColor: theme.palette.divider
        })
    }
};
//# sourceMappingURL=Skeleton.js.map